import {AxiosError} from 'axios';
import {equals, hasPath, path} from 'ramda';
import {ErrorCode as ApiErrorCode} from '../types/error/ErrorCode';

export const isValidationError = (error: AxiosError) => {
  const errorCodePath = ['response', 'data', 'errorCode'];

  return hasPath(errorCodePath) &&
    equals(path<ApiErrorCode | undefined>(errorCodePath, error), ApiErrorCode.VALIDATION_ERROR);
}